import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  Platform,
  TouchableOpacity,
  TextInput,
  ScrollView,
  ActivityIndicator,
} from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import Svg, { Path } from 'react-native-svg';
import DLOModal from '../DLOModal';
import DLODropdown from '../DLODropdown';
import DLOButton from '../DLOButton';
import DLORadioButton from '../DLORadioButton';
import DLOTooltip from '../DLOTooltip';
import { DLODropdownOption } from '../../types/dlo.types';
import { apiClient, createApiClient } from '../../../../api/apiClient';
import { RootState } from '../../../../store';
import { 
  setHistoricalHoursUnsavedChanges, 
  selectHistoricalHoursUnsavedChanges 
} from '../../../../store/slices/dloSlice';

// Add Zone Icon
const AddZoneIcon = ({ color = '#FFFFFF' }) => (
  <Svg width="20" height="20" viewBox="0 0 21 20" fill="none">
    <Path
      d="M16.0217 10.8334H11.0217V15.8334H9.355V10.8334H4.355V9.16675H9.355V4.16675H11.0217V9.16675H16.0217V10.8334Z"
      fill={color}
    />
  </Svg>
);

// Drag Handle Icon
const DragHandleIcon = ({ color = '#CCCCCC' }) => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <Path
      d="M6 3.5C6 4.32843 5.32843 5 4.5 5C3.67157 5 3 4.32843 3 3.5C3 2.67157 3.67157 2 4.5 2C5.32843 2 6 2.67157 6 3.5Z"
      fill={color}
    />
    <Path
      d="M13 3.5C13 4.32843 12.3284 5 11.5 5C10.6716 5 10 4.32843 10 3.5C10 2.67157 10.6716 2 11.5 2C12.3284 2 13 2.67157 13 3.5Z"
      fill={color}
    />
    <Path
      d="M6 8C6 8.82843 5.32843 9.5 4.5 9.5C3.67157 9.5 3 8.82843 3 8C3 7.17157 3.67157 6.5 4.5 6.5C5.32843 6.5 6 7.17157 6 8Z"
      fill={color}
    />
    <Path
      d="M13 8C13 8.82843 12.3284 9.5 11.5 9.5C10.6716 9.5 10 8.82843 10 8C10 7.17157 10.6716 6.5 11.5 6.5C12.3284 6.5 13 7.17157 13 8Z"
      fill={color}
    />
    <Path
      d="M6 12.5C6 13.3284 5.32843 14 4.5 14C3.67157 14 3 13.3284 3 12.5C3 11.6716 3.67157 11 4.5 11C5.32843 11 6 11.6716 6 12.5Z"
      fill={color}
    />
    <Path
      d="M13 12.5C13 13.3284 12.3284 14 11.5 14C10.6716 14 10 13.3284 10 12.5C10 11.6716 10.6716 11 11.5 11C12.3284 11 13 11.6716 13 12.5Z"
      fill={color}
    />
  </Svg>
);

// Action Icons from Figma
const SaveIcon = ({ color = '#3A3A3A' }) => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path
      d="M14.1667 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V5.83333L14.1667 2.5ZM15.8333 15.8333H4.16667V4.16667H13.475L15.8333 6.525V15.8333ZM10 10C8.61667 10 7.5 11.1167 7.5 12.5C7.5 13.8833 8.61667 15 10 15C11.3833 15 12.5 13.8833 12.5 12.5C12.5 11.1167 11.3833 10 10 10ZM5 5H12.5V8.33333H5V5Z"
      fill={color}
    />
  </Svg>
);

const ClearIcon = ({ color = '#3A3A3A' }) => (
 <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none">
<path d="M12.6773 12.5H16.6356V14.1667H11.0106L12.6773 12.5ZM2.26064 14.1667L0.489805 12.3958C0.170361 12.0764 0.00716608 11.6806 0.000221631 11.2083C-0.00672281 10.7361 0.149527 10.3333 0.468972 10L9.63564 0.5C9.95508 0.166667 10.3474 0 10.8127 0C11.278 0 11.6704 0.159722 11.9898 0.479167L16.1356 4.625C16.4551 4.94444 16.6148 5.34028 16.6148 5.8125C16.6148 6.28472 16.4551 6.68056 16.1356 7L9.13564 14.1667H2.26064ZM8.42731 12.5L14.969 5.79167L10.844 1.66667L1.63564 11.1667L2.96897 12.5H8.42731Z" fill={color}/>
</svg>
);

const HistoryIcon = ({ color = '#3A3A3A' }) => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path
      d="M10.8335 2.5C6.69183 2.5 3.3335 5.85833 3.3335 10H0.833496L4.07516 13.2417L4.1335 13.3583L7.50016 10H5.00016C5.00016 6.775 7.6085 4.16667 10.8335 4.16667C14.0585 4.16667 16.6668 6.775 16.6668 10C16.6668 13.225 14.0585 15.8333 10.8335 15.8333C9.22516 15.8333 7.76683 15.175 6.71683 14.1167L5.5335 15.3C6.89183 16.6583 8.7585 17.5 10.8335 17.5C14.9752 17.5 18.3335 14.1417 18.3335 10C18.3335 5.85833 14.9752 2.5 10.8335 2.5ZM10.0002 6.66667V10.8333L13.5418 12.9333L14.1835 11.8667L11.2502 10.125V6.66667H10.0002Z"
      fill={color}
    />
  </Svg>
);

// API data structure from backend
interface ApiDataItem {
  ID: number;
  "Loc ID": string;
  "Location Name": string;
  VP_Zone: string;
  day_num: number;
  YR: number;
  PRD: number;
  WK: number;
  CreatedAt: string;
  CreatedBy: string;
  ModifiedAt: string | null;
  ModifiedBy: string | null;
  historical_hours: number;
  fixed_hours: number | null;
}

interface ApiResponse {
  success: boolean;
  message: string;
  data: ApiDataItem[];
  metadata: {
    recordCount: number;
    responseTime: string;
    location: string;
    period: number;
    week: number;
    type: string;
    timestamp: string;
  };
}

interface ScheduleRow {
  id: string;
  zone: string;
  historicalHours: {
    sun: string;
    mon: string;
    tue: string;
    wed: string;
    thu: string;
    fri: string;
    sat: string;
  };
  fixedHours: {
    sun: string;
    mon: string;
    tue: string;
    wed: string;
    thu: string;
    fri: string;
    sat: string;
  };
  __changed?: { [day: string]: boolean }; // Track which days user modified
  __actualFixedHours?: { [day: string]: boolean }; // Track which days have non-null fixed_hours from backend
}

interface AvailableZone {
  id: string;
  name: string;
  enabled: boolean;
  inTable?: boolean; // Track if zone is already in the table
}

interface UpdateRecord {
  vpZone: string;
  dayNum: number;
  fixedHours: number;
}

interface ChangeTracker {
  [rowId: string]: {
    [day: string]: boolean; // tracks if this day has unsaved changes
  };
}

export interface HistoricalHoursByDayAverageProps {
  data?: ScheduleRow[] | ApiResponse; // Can accept either processed data or raw API response
  value?: ScheduleRow[];
  onChange?: (data: ScheduleRow[]) => void;
  onSave?: () => void;
  onAddZone?: () => void;
  onZoneAdded?: (zone: string) => void;
  onRowSave?: (rowId: string) => void;
  onRowClear?: (rowId: string) => void;
  onRowRestore?: (rowId: string) => void;
  isLoading?: boolean;
  isSaved?: boolean;
  isSaving?: boolean;
  context?: 'schedule-settings' | 'location-settings';
  style?: any;
}

const HistoricalHoursByDayAverage: React.FC<HistoricalHoursByDayAverageProps> = ({
  data = [],
  value,
  onChange,
  onSave,
  onAddZone,
  onZoneAdded,
  onRowSave,
  onRowClear,
  onRowRestore,
  isLoading: externalLoading = false,
  isSaved = false,
  isSaving = false,
  context = 'location-settings',
  style
}) => {
  // Helper function to check if data is API response format
  const isApiResponse = (data: any): data is ApiResponse => {
    return data && typeof data === 'object' && 'success' in data && 'data' in data && Array.isArray(data.data);
  };

  // Helper function to convert API data to ScheduleRow format
  const convertApiDataToScheduleRows = (apiData: ApiDataItem[]): ScheduleRow[] => {
    // Group by VP_Zone
    const groupedByZone: { [zone: string]: ApiDataItem[] } = {};
    
    apiData.forEach(item => {
      if (!groupedByZone[item.VP_Zone]) {
        groupedByZone[item.VP_Zone] = [];
      }
      groupedByZone[item.VP_Zone].push(item);
    });

    // Convert each zone group to a ScheduleRow
    return Object.keys(groupedByZone).map((zone, index) => {
      const zoneData = groupedByZone[zone];
      
      // Initialize hours objects
      const historicalHours = {
        sun: '0', mon: '0', tue: '0', wed: '0', thu: '0', fri: '0', sat: '0'
      };
      const fixedHours = {
        sun: '', mon: '', tue: '', wed: '', thu: '', fri: '', sat: ''
      };
      
      // Track which days have actual backend fixed_hours (non-null)
      const actualFixedHours: { [day: string]: boolean } = {};
      
      // Map day_num to day names (1=Sunday, 2=Monday, etc.)
      const dayMap: { [key: number]: keyof typeof historicalHours } = {
        1: 'sun', 2: 'mon', 3: 'tue', 4: 'wed', 5: 'thu', 6: 'fri', 7: 'sat'
      };
      
      // Populate hours from API data
      zoneData.forEach(item => {
        const dayKey = dayMap[item.day_num];
        if (dayKey) {
          historicalHours[dayKey] = item.historical_hours?.toString() || '0';
          
          // Check if fixed_hours is null from backend
          if (item.fixed_hours !== null && item.fixed_hours !== undefined) {
            // Backend has actual fixed_hours value
            fixedHours[dayKey] = item.fixed_hours.toString();
            actualFixedHours[dayKey] = true;
          } else {
            // Backend fixed_hours is null - copy historical hours
            fixedHours[dayKey] = item.historical_hours?.toString() || '0';
            actualFixedHours[dayKey] = false;
          }
        }
      });
      
      return {
        id: (index + 1).toString(),
        zone: zone,
        historicalHours,
        fixedHours,
        __actualFixedHours: actualFixedHours,
        __changed: {} // Initialize empty - no user modifications yet
      };
    });
  };

  // Extract available zones from API data - gets ALL unique VP_Zone values
  const extractAvailableZones = (apiData: ApiDataItem[]): string[] => {
    const zones = new Set<string>();
    apiData.forEach(item => {
      if (item.VP_Zone) {
        zones.add(item.VP_Zone);
      }
    });
    return Array.from(zones).sort();
  };

  // Process the input data
  let processedData: ScheduleRow[] = [];
  let allAvailableZones: string[] = [];

  if (isApiResponse(data)) {
    // Convert API response to ScheduleRow format
    processedData = convertApiDataToScheduleRows(data.data);
    // Extract ALL unique zones from API data
    allAvailableZones = extractAvailableZones(data.data);
  } else if (Array.isArray(data)) {
    // Already in ScheduleRow format
    processedData = data;
    // For backward compatibility - extract zones from existing data
    allAvailableZones = Array.from(new Set(data.map(row => row.zone))).sort();
  }

  // Use value prop if provided (for controlled component), otherwise use processed data
  const scheduleData = value && value.length > 0 ? value : processedData;
  
  // Step 6: Never hardcode zone values - use dynamic data from API
  // If no data is provided, create default data using first available zone (if any)
  const getDefaultData = (): ScheduleRow[] => {
    if (allAvailableZones.length === 0) {
      return []; // No zones available, return empty array
    }
    
    // Create default row using first available zone
    const firstZone = allAvailableZones[0];
    return [
      {
        id: '1',
        zone: firstZone,
        historicalHours: {
          sun: '0',
          mon: '0',
          tue: '0',
          wed: '0',
          thu: '0',
          fri: '0',
          sat: '0',
        },
        fixedHours: {
          sun: '',
          mon: '',
          tue: '',
          wed: '',
          thu: '',
          fri: '',
          sat: '',
        },
      },
    ];
  };

  // Use actual data or fallback to dynamic default
  const currentData = scheduleData && scheduleData.length > 0 ? scheduleData : getDefaultData();

  // Helper function to update data via parent component
  const updateScheduleData = (newData: ScheduleRow[] | ((prev: ScheduleRow[]) => ScheduleRow[])) => {
    let updatedData: ScheduleRow[];
    
    if (typeof newData === 'function') {
      updatedData = newData(currentData || []);
    } else {
      updatedData = newData;
    }
    
    // Also update the complete original data to preserve user changes
    // Merge with existing complete original data to maintain zones that aren't currently visible
    setCompleteOriginalData(prevCompleteData => {
      const updatedCompleteData = [...prevCompleteData];
      
      // Update existing zones or add new ones
      updatedData.forEach(updatedRow => {
        const existingIndex = updatedCompleteData.findIndex(row => row.zone === updatedRow.zone);
        if (existingIndex >= 0) {
          // Update existing zone data
          updatedCompleteData[existingIndex] = updatedRow;
        } else {
          // Add new zone data
          updatedCompleteData.push(updatedRow);
        }
      });
      
      return updatedCompleteData;
    });
    
    onChange?.(updatedData);
  };

  // Store original data for restore functionality - use the current data as baseline
  const originalData = currentData;
  
  // Store complete API data to preserve zone values when zones are removed and re-added
  const [completeOriginalData, setCompleteOriginalData] = useState<ScheduleRow[]>([]);

  const [hoveredButton, setHoveredButton] = useState<string | null>(null);
  const [isAddZoneModalVisible, setIsAddZoneModalVisible] = useState(false);
  const [selectedZone, setSelectedZone] = useState<DLODropdownOption | null>(null);
  const [modalZones, setModalZones] = useState<AvailableZone[]>([]);

  // Initialize complete original data when processed data changes
  useEffect(() => {
    if (processedData && processedData.length > 0 && completeOriginalData.length === 0) {
      console.log('Setting complete original data from processed data:', processedData);
      setCompleteOriginalData([...processedData]);
    }
  }, [processedData, completeOriginalData.length]);

  // Initialize modal zones based on available zones from API - NO HARDCODED ZONES
  useEffect(() => {
    // Only initialize when allAvailableZones changes AND modalZones is empty
    // This ensures ALL zones are always available in the modal but doesn't reset user changes
    if (allAvailableZones && allAvailableZones.length > 0 && modalZones.length === 0) {
      // Initialize based on current table state - zones in table are enabled, others disabled
      const currentTableZones = currentData ? currentData.map(row => row.zone) : [];
      const initialModalZones = allAvailableZones.map((zoneName: string) => ({
        id: zoneName.toLowerCase(),
        name: zoneName,
        enabled: currentTableZones.includes(zoneName), // Enable only if already in table
        inTable: currentTableZones.includes(zoneName),
      }));
      
      console.log('Initializing modal zones from API data:', allAvailableZones);
      console.log('Initial modal zones list:', initialModalZones.map((z: AvailableZone) => z.name));
      setModalZones(initialModalZones);
    }
  }, [allAvailableZones]); // Only depend on allAvailableZones, initialize once
  
  // New state for tracking changes and API calls
  const [isLoading, setIsLoading] = useState(false);
  const [savingRowId, setSavingRowId] = useState<string | null>(null);
  const [apiMessage, setApiMessage] = useState<{ type: 'success' | 'error'; message: string } | null>(null);
  const [showApiModal, setShowApiModal] = useState(false);
  
  // Redux selectors and dispatch
  const dispatch = useDispatch();
  const selectedLocation = useSelector((state: RootState) => state.appData?.selectedLocation);
  const unsavedChanges = useSelector(selectHistoricalHoursUnsavedChanges);

  // Helper function to update unsaved changes in Redux
  const setUnsavedChanges = (changes: ChangeTracker) => {
    dispatch(setHistoricalHoursUnsavedChanges(changes));
  };

  // Generate zone options dynamically based on modal zones
  const zoneOptions: DLODropdownOption[] = (modalZones || []).map(zone => ({
    id: zone.id,
    label: zone.name.charAt(0) + zone.name.slice(1).toLowerCase(), // Proper case
    value: zone.name
  }));

  const dayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // Handle zone toggle in modal
  const handleZoneToggle = (zoneId: string, enabled: boolean) => {
    setModalZones(prev => (prev || []).map(zone => 
      zone.id === zoneId ? { ...zone, enabled } : zone
    ));
  };

  const updateHistoricalHours = (rowId: string, day: string, value: string) => {
    updateScheduleData(prev => (prev || []).map(row => 
      row.id === rowId 
        ? { ...row, historicalHours: { ...row.historicalHours, [day]: value } }
        : row
    ));
  };

  const updateFixedHours = (rowId: string, day: string, value: string) => {
    // Only update if the input is valid
    if (validateDecimalInput(value)) {
      updateScheduleData(prev => (prev || []).map(row => {
        if (row.id === rowId) {
          // Normalize values for comparison
          const normalizeValue = (val: string) => {
            const cleaned = val.trim();
            const parsed = parseFloat(cleaned);
            return isNaN(parsed) ? 0 : parsed;
          };
          
          // Determine baseline to compare against
          let baseline: string;
          const hasBackendFixedHours = row.__actualFixedHours?.[day];
          
          if (hasBackendFixedHours) {
            // If backend has actual fixed_hours, compare against that
            // We need to get the original value from backend
            baseline = row.fixedHours[day as keyof typeof row.fixedHours];
          } else {
            // If backend fixed_hours was null, compare against historical hours
            baseline = row.historicalHours[day as keyof typeof row.historicalHours];
          }
          
          // Check if value actually changed from baseline
          const normalizedValue = normalizeValue(value);
          const normalizedBaseline = normalizeValue(baseline);
          const isDifferent = normalizedValue !== normalizedBaseline;
          
          // Update __changed metadata
          const changed = { ...row.__changed, [day]: isDifferent };
          
          return { 
            ...row, 
            fixedHours: { ...row.fixedHours, [day]: value },
            __changed: changed
          };
        }
        return row;
      }));
      
      // Also track in Redux for backward compatibility
      setUnsavedChanges({
        ...unsavedChanges,
        [rowId]: {
          ...unsavedChanges[rowId],
          [day]: true
        }
      });
    }
  };

  const isSaveDisabled = () => {
    // Check if any row has actual user modifications using __changed metadata
    const hasAnyChanges = (currentData || []).some(row => 
      row.__changed && Object.values(row.__changed).some(isChanged => isChanged === true)
    );
    
    // Also check unsavedChanges from Redux state for robustness
    const hasUnsavedChanges = Object.keys(unsavedChanges).length > 0 && 
      Object.values(unsavedChanges).some(rowChanges => 
        rowChanges && typeof rowChanges === 'object' && Object.keys(rowChanges as object).length > 0
      );
    
    return (!hasAnyChanges && !hasUnsavedChanges) || isSaving;
  };

  const handleAddZone = () => {
    console.log('Opening Add Zone modal');
    console.log('Current data zones:', (currentData || []).map(row => row.zone));
    console.log('Available zones from API data:', allAvailableZones);
    
    // Update modal zones to reflect current table state when opening modal
    // IMPORTANT: Only update enabled/inTable states, don't recreate the entire list
    const currentTableZones = currentData ? currentData.map(row => row.zone) : [];
    
    if (modalZones.length > 0) {
      // Update existing modal zones with current table state
      const updatedModalZones = modalZones.map((zone: AvailableZone) => ({
        ...zone,
        enabled: currentTableZones.includes(zone.name),
        inTable: currentTableZones.includes(zone.name),
      }));
      setModalZones(updatedModalZones);
    } else {
      // First time opening modal - create initial zones
      const initialModalZones = (allAvailableZones || []).map((zoneName: string) => ({
        id: zoneName.toLowerCase(),
        name: zoneName,
        enabled: currentTableZones.includes(zoneName),
        inTable: currentTableZones.includes(zoneName),
      }));
      setModalZones(initialModalZones);
    }
    
    console.log('Updated modal zones for current table state');
    setIsAddZoneModalVisible(true);
  };

  const handleZoneModalSave = () => {
    // Step 4: Create table data based only on ENABLED zones
    // Zones that are disabled (turned off) will be hidden from table but remain in modal
    const enabledZones = modalZones.filter((zone: AvailableZone) => zone.enabled);
    console.log('Saving modal with enabled zones:', enabledZones.map(z => z.name));
    console.log('Complete original data available:', completeOriginalData.map(r => ({ zone: r.zone, fixedHours: r.fixedHours })));
    
    // Create new table data with only enabled zones
    let updatedData: ScheduleRow[] = enabledZones.map((zone: AvailableZone, index: number) => {
      // First check if zone already exists in current data to preserve values
      let existingRow = currentData.find(row => row.zone === zone.name);
      let dataSource = 'current';
      
      // If not found in current data, check the complete original data to restore previous values
      if (!existingRow) {
        existingRow = completeOriginalData.find(row => row.zone === zone.name);
        dataSource = 'original';
      }
      
      if (existingRow) {
        console.log(`Restoring zone ${zone.name} from ${dataSource} data:`, existingRow.fixedHours);
        // Keep existing data for this zone (either from current or original data)
        return {
          ...existingRow,
          id: (index + 1).toString(), // Update ID to maintain sequence
        };
      } else {
        console.log(`Creating new zone ${zone.name} with default values`);
        // Create new row for truly new zone (not in either current or original data)
        return {
          id: (index + 1).toString(),
          zone: zone.name,
          historicalHours: {
            sun: '0',
            mon: '0',
            tue: '0',
            wed: '0',
            thu: '0',
            fri: '0',
            sat: '0',
          },
          fixedHours: {
            sun: '',
            mon: '',
            tue: '',
            wed: '',
            thu: '',
            fri: '',
            sat: '',
          },
        };
      }
    });

    // Update the table data - this will hide disabled zones from table
    updateScheduleData(updatedData);
    
    // Close modal
    setIsAddZoneModalVisible(false);
    
    // Call callbacks if provided
    onAddZone?.();
    
    // Call onZoneAdded for newly added zones
    const newlyEnabledZones = enabledZones.filter((zone: AvailableZone) => 
      !currentData.some(row => row.zone === zone.name)
    );
    newlyEnabledZones.forEach((zone: AvailableZone) => onZoneAdded?.(zone.name));
  };

  const handleZoneModalCancel = () => {
    // Reset modal zones to reflect current table state but keep ALL zones visible in modal
    // IMPORTANT: Only update enabled/inTable states, don't recreate the entire list
    const currentTableZones = currentData ? currentData.map(row => row.zone) : [];
    
    // Update existing modal zones to reset their enabled state to match table
    const resetModalZones = modalZones.map((zone: AvailableZone) => ({
      ...zone,
      enabled: currentTableZones.includes(zone.name), // Only enable if currently in table
      inTable: currentTableZones.includes(zone.name),
    }));
    
    setModalZones(resetModalZones);
    setIsAddZoneModalVisible(false);
  };

  // Helper function to convert day name to day number (1=Sunday, 2=Monday, etc.)
  const getDayNumber = (day: string): number => {
    const dayMap: { [key: string]: number } = {
      'sun': 1, 'mon': 2, 'tue': 3, 'wed': 4, 'thu': 5, 'fri': 6, 'sat': 7
    };
    return dayMap[day] || 1;
  };

  // Helper function to convert day number back to day name
  const getDayName = (dayNum: number): string => {
    const dayNames = ['', 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    return dayNames[dayNum] || 'sun';
  };

  // Helper function to validate decimal input (allows up to 2 decimal places)
  const validateDecimalInput = (value: string): boolean => {
    if (!value || value === '') return true;
    
    // Only allow numbers and one decimal point with up to 2 decimal places
    // No special characters, symbols, or letters allowed
    const decimalRegex = /^[0-9]*\.?[0-9]{0,2}$/;
    return decimalRegex.test(value);
  };

  // Helper function to format decimal values to 2 decimal places
  const formatDecimalValue = (value: string): string => {
    if (!value || value === '') return '';
    
    // Parse and validate the number
    const parsed = parseFloat(value);
    if (isNaN(parsed)) return value; // Return original if invalid
    
    // Format to 2 decimal places
    return parsed.toFixed(2);
  };

  // Format decimal values on blur
  const handleDecimalBlur = (rowId: string, day: string, value: string) => {
    const formattedValue = formatDecimalValue(value);
    if (formattedValue !== value && formattedValue !== '') {
      updateScheduleData(prev => (prev || []).map(row => 
        row.id === rowId 
          ? { ...row, fixedHours: { ...row.fixedHours, [day]: formattedValue } }
          : row
      ));
    }
  };

  // Save individual row
  const handleRowSave = async (rowId: string) => {
    const row = (currentData || []).find(r => r.id === rowId);
    
    // Check if row has any actual user modifications
    const hasChanges = row?.__changed && Object.values(row.__changed).some(isChanged => isChanged === true);
    
    if (!row || !hasChanges) return;

    setSavingRowId(rowId);
    const updates: UpdateRecord[] = [];
    
    // When user clicks row save, send ALL 7 days with their current fixed_hours values
    const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    days.forEach(day => {
      const fixedHours = parseFloat(row.fixedHours[day as keyof typeof row.fixedHours]);
      if (!isNaN(fixedHours)) {
        updates.push({
          vpZone: row.zone,
          dayNum: getDayNumber(day),
          fixedHours: fixedHours
        });
      }
    });

    if (updates.length > 0) {
      if (context === 'schedule-settings') {
        // For Schedule Settings, call external onRowSave with rowId
        // Parent will handle API call with period/week parameters
        onRowSave?.(rowId);
        
        // Clear __changed for this row after save is initiated
        updateScheduleData(prev => (prev || []).map(r => 
          r.id === rowId ? { ...r, __changed: {} } : r
        ));
        
        // Also clear Redux unsavedChanges for backward compatibility
        const { [rowId]: _, ...remainingChanges } = unsavedChanges;
        setUnsavedChanges(remainingChanges);
      } else {
        // For Location Settings, call external onRowSave
        onRowSave?.(rowId);
        
        // Clear __changed for this row after save is initiated
        updateScheduleData(prev => (prev || []).map(r => 
          r.id === rowId ? { ...r, __changed: {} } : r
        ));
        
        // Also clear Redux unsavedChanges for backward compatibility
        const { [rowId]: _, ...remainingChanges } = unsavedChanges;
        setUnsavedChanges(remainingChanges);
      }
    }
    setSavingRowId(null);
  };

  // Save all unsaved changes
  const handleBulkSave = async () => {
    const updates: UpdateRecord[] = [];
    
    // For Global Save: Only send zones/days that user actually modified
    (currentData || []).forEach(row => {
      if (row.__changed) {
        // Check each day to see if user modified it
        Object.entries(row.__changed).forEach(([day, isChanged]) => {
          if (isChanged) {
            // User modified this day - send its current fixed_hours value
            const fixedHours = parseFloat(row.fixedHours[day as keyof typeof row.fixedHours]);
            if (!isNaN(fixedHours)) {
              updates.push({
                vpZone: row.zone,
                dayNum: getDayNumber(day),
                fixedHours: fixedHours
              });
            }
          }
        });
      }
    });

    if (updates.length > 0) {
      if (context === 'schedule-settings') {
        // For Schedule Settings, call external onSave callback
        // Parent will handle API call with period/week parameters
        onSave?.();
        
        // Clear all __changed metadata after save is initiated
        updateScheduleData(prev => (prev || []).map(row => ({ ...row, __changed: {} })));
        
        // Also clear Redux unsavedChanges for backward compatibility
        setUnsavedChanges({});
      } else {
        // For Location Settings, call external onSave callback
        // Parent handles API call with location-specific parameters
        onSave?.();
        
        // Clear all __changed metadata after save is initiated
        updateScheduleData(prev => (prev || []).map(row => ({ ...row, __changed: {} })));
        
        // Also clear Redux unsavedChanges for backward compatibility
        setUnsavedChanges({});
      }
    }
  };

  // Clear all values for a row (sets non-empty cells to 0, leaves empty cells empty)
  const handleRowClear = (rowId: string) => {
    // Find the current row to check if it has any values
    const currentRow = (currentData || []).find(row => row.id === rowId);
    if (!currentRow) return;
    
    // Check if there are any non-empty/non-zero values in fixedHours
    const dayKeys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const hasValues = dayKeys.some(day => {
      const value = currentRow.fixedHours[day as keyof typeof currentRow.fixedHours];
      return value && value.trim() !== '' && value !== '0' && value !== '0.00';
    });
    
    // Only proceed if there are actual values to clear
    if (!hasValues) {
      // Row is already empty/cleared, no action needed
      return;
    }
    
    // Mark only the days that had values as changed (those cells need to be saved as 0)
    const rowChanges: { [day: string]: boolean } = {};
    dayKeys.forEach(day => {
      const value = currentRow.fixedHours[day as keyof typeof currentRow.fixedHours];
      // Mark as changed if it had a non-zero value
      if (value && value.trim() !== '' && value !== '0' && value !== '0.00') {
        rowChanges[day] = true;
      }
    });
    
    // Update the data - set only cells with values to 0, keep empty cells empty
    // Also update __changed metadata so handleBulkSave knows which days to save
    updateScheduleData(prev => (prev || []).map(row => 
      row.id === rowId 
        ? { 
            ...row, 
            fixedHours: {
              sun: (row.fixedHours.sun && row.fixedHours.sun.trim() !== '' && row.fixedHours.sun !== '0' && row.fixedHours.sun !== '0.00') ? '0' : row.fixedHours.sun,
              mon: (row.fixedHours.mon && row.fixedHours.mon.trim() !== '' && row.fixedHours.mon !== '0' && row.fixedHours.mon !== '0.00') ? '0' : row.fixedHours.mon,
              tue: (row.fixedHours.tue && row.fixedHours.tue.trim() !== '' && row.fixedHours.tue !== '0' && row.fixedHours.tue !== '0.00') ? '0' : row.fixedHours.tue,
              wed: (row.fixedHours.wed && row.fixedHours.wed.trim() !== '' && row.fixedHours.wed !== '0' && row.fixedHours.wed !== '0.00') ? '0' : row.fixedHours.wed,
              thu: (row.fixedHours.thu && row.fixedHours.thu.trim() !== '' && row.fixedHours.thu !== '0' && row.fixedHours.thu !== '0.00') ? '0' : row.fixedHours.thu,
              fri: (row.fixedHours.fri && row.fixedHours.fri.trim() !== '' && row.fixedHours.fri !== '0' && row.fixedHours.fri !== '0.00') ? '0' : row.fixedHours.fri,
              sat: (row.fixedHours.sat && row.fixedHours.sat.trim() !== '' && row.fixedHours.sat !== '0' && row.fixedHours.sat !== '0.00') ? '0' : row.fixedHours.sat
            },
            __changed: {
              ...row.__changed,
              ...rowChanges
            }
          }
        : row
    ));
    
    setUnsavedChanges({
      ...unsavedChanges,
      [rowId]: rowChanges
    });
    
    onRowClear?.(rowId);
  };

  // Restore fixed hours to initial/original values
  const handleRowRestore = (rowId: string) => {
    // Find the original data for this row - first check current row zone
    const currentRow = (currentData || []).find(row => row.id === rowId);
    if (!currentRow) return;
    
    // Find the original data using the zone name from complete original data
    const originalRow = completeOriginalData.find(row => row.zone === currentRow.zone);
    
    if (originalRow) {
      // Mark all days as having unsaved changes since we just copied historical to fixed
      const dayKeys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      const rowChanges: { [day: string]: boolean } = {};
      dayKeys.forEach(day => {
        // Only mark as changed if there's a value to save
        if (originalRow.historicalHours[day as keyof typeof originalRow.historicalHours]) {
          rowChanges[day] = true;
        }
      });
      
      // Copy historical hours to fixed hours (restore functionality)
      // Also update __changed metadata so handleBulkSave knows which days to save
      updateScheduleData(prev => (prev || []).map(row => 
        row.id === rowId 
          ? { 
              ...row, 
              fixedHours: { ...originalRow.historicalHours },
              __changed: {
                ...row.__changed,
                ...rowChanges
              }
            }
          : row
      ));
      
      setUnsavedChanges({
        ...unsavedChanges,
        [rowId]: rowChanges
      });
    } else {
      // If no original data found, clear the values (for newly added rows)
      updateScheduleData(prev => (prev || []).map(row => 
        row.id === rowId 
          ? { 
              ...row, 
              fixedHours: {
                sun: '',
                mon: '',
                tue: '',
                wed: '',
                thu: '',
                fri: '',
                sat: ''
              },
              __changed: {}
            }
          : row
      ));
      
      // Clear unsaved changes for this row since we cleared the values
      const updated = { ...unsavedChanges };
      delete updated[rowId];
      setUnsavedChanges(updated);
    }
    
    // Call the callback if provided
    onRowRestore?.(rowId);
  };

  return (
    <ScrollView 
      horizontal 
      showsHorizontalScrollIndicator={Platform.OS === 'web'}
      contentContainerStyle={styles.scrollContainer}
    >
      <View style={[styles.container, style]}>
        {/* Main Header */}
        <View style={styles.mainHeader}>

          <TouchableOpacity 
            style={styles.addZoneButton}
            onPress={handleAddZone}
            activeOpacity={0.7}
          >
            <Text style={styles.addZoneText}>Edit Zone</Text>
          </TouchableOpacity>

          <View style={styles.headerDivider} />

          <View style={styles.historicalSection}>
            <Text style={styles.headerSectionText}>HISTORICAL HOURS BY DAY AVERAGE</Text>
          </View>

          <View style={styles.headerDividerAfterHistorySection} />

          <View style={styles.fixedSection}>
            <Text style={styles.headerSectionText}>FIXED HOURS BY DAY</Text>
          </View>

          <View style={styles.headerDivider} />
          <View style={styles.actionSection}>
            <Text style={styles.headerSectionText}>ACTION</Text>
          </View>
        </View>

        {/* Sub Header */}
        <View style={styles.subHeader}>
          <View style={styles.zoneSubColumn}>
            <Text style={styles.subHeaderText}>Zones</Text>
          </View>

          {/* Historical Hours Days */}
          <View style={styles.historicalDaysGroup}>
            {dayLabels.map((day, index) => (
              <React.Fragment key={`hist-${day}`}>
                <View style={styles.dayColumnDivider} />
                <View style={styles.daySubColumn}>
                  <Text style={styles.subHeaderText}>{day}</Text>
                </View>
              </React.Fragment>
            ))}
          </View>

          {/* Fixed Hours Days */}
          <View style={styles.fixedDaysGroup}>
            {dayLabels.map((day, index) => (
              <React.Fragment key={`fixed-${day}`}>
                <View style={styles.dayColumnDivider} />
                <View style={styles.daySubColumn}>
                  <Text style={styles.subHeaderText}>{day}</Text>
                </View>
              </React.Fragment>
            ))}
            <View style={styles.dayColumnDivider} />
          </View>

          <View style={styles.actionSubColumn}>
            <Text style={styles.subHeaderText}> </Text>
          </View>
        </View>

        {/* Data Rows */}
        {currentData && currentData.map((row, rowIndex) => (
          <View key={row.id} style={[
            styles.dataRow, 
            rowIndex === (currentData.length - 1) && { borderBottomWidth: 0 }
          ]}>
            <View style={styles.zoneSubColumn}>
              <Text style={[styles.zoneText, { fontWeight: 'bold' }]}>{row.zone}</Text>
            </View>
            
            {/* Historical Hours Inputs */}
            <View style={styles.historicalDaysGroup}>
              {dayLabels.map((day) => (
                <React.Fragment key={`hist-input-${day}`}>
                  <View style={styles.inputColumnDivider} />
                  <View style={styles.daySubColumn}>
                    <View style={styles.inputContainer}>
                      <TextInput
                        style={[styles.input, styles.historicalInput]}
                        value={row.historicalHours[day.toLowerCase() as keyof typeof row.historicalHours]}
                        onChangeText={(value) => updateHistoricalHours(row.id, day.toLowerCase(), value)}
                        placeholder="0"
                        placeholderTextColor="#999"
                        maxLength={10}
                        editable={false}
                        pointerEvents="none"
                      />
                    </View>
                  </View>
                </React.Fragment>
              ))}
            </View>

            {/* Fixed Hours Inputs */}
            <View style={styles.fixedDaysGroup}>
              {dayLabels.map((day) => (
                <React.Fragment key={`fixed-input-${day}`}>
                  <View style={styles.inputColumnDivider} />
                  <View style={styles.daySubColumn}>
                    <View style={styles.inputContainer}>
                      <TextInput
                        style={[styles.input, styles.fixedInput]}
                        value={row.fixedHours[day.toLowerCase() as keyof typeof row.fixedHours]}
                        onChangeText={(value) => updateFixedHours(row.id, day.toLowerCase(), value)}
                        onBlur={() => handleDecimalBlur(row.id, day.toLowerCase(), row.fixedHours[day.toLowerCase() as keyof typeof row.fixedHours])}
                        placeholder=" "
                        placeholderTextColor="#3A3A3A"
                        maxLength={8}
                        keyboardType="decimal-pad"
                      />
                    </View>
                  </View>
                </React.Fragment>
              ))}
              <View style={styles.inputColumnDivider} />
            </View>

            <View style={styles.actionSubColumn}>
              <View style={styles.actionButtonsContainer}>
                <DLOTooltip 
                  content="Clear" 
                  position="top" 
                  trigger="hover" 
                  verticalOffset={30}
                  horizontalOffset={-10}
                  maxWidth={45}
                  minWidth={60}
                  padding={6}
                  textAlign="center"
                >
                  <TouchableOpacity
                    style={styles.actionButton}
                    onPress={() => handleRowClear(row.id)}
                    onPressIn={() => setHoveredButton(`${row.id}-clear`)}
                    onPressOut={() => setHoveredButton(null)}
                    {...Platform.select({
                      web: {
                        onMouseEnter: () => setHoveredButton(`${row.id}-clear`),
                        onMouseLeave: () => setHoveredButton(null),
                      },
                    })}
                    activeOpacity={0.7}
                    disabled={savingRowId === row.id}
                  >
                    <ClearIcon color={
                      savingRowId === row.id 
                        ? '#D0D0D0' 
                        : hoveredButton === `${row.id}-clear` 
                          ? 'rgb(0, 92, 188)' 
                          : '#3A3A3A'
                    } />
                  </TouchableOpacity>
                </DLOTooltip>
                <DLOTooltip 
                  content="Restore" 
                  position="top" 
                  trigger="hover" 
                  verticalOffset={30}
                  horizontalOffset={-10}
                  maxWidth={45}
                  minWidth={60}
                  padding={6}
                  textAlign="center"
                >
                  <TouchableOpacity
                    style={styles.actionButton}
                    onPress={() => handleRowRestore(row.id)}
                    onPressIn={() => setHoveredButton(`${row.id}-restore`)}
                    onPressOut={() => setHoveredButton(null)}
                    {...Platform.select({
                      web: {
                        onMouseEnter: () => setHoveredButton(`${row.id}-restore`),
                        onMouseLeave: () => setHoveredButton(null),
                      },
                    })}
                    activeOpacity={0.7}
                    disabled={savingRowId === row.id}
                  >
                    <HistoryIcon color={
                      savingRowId === row.id 
                        ? '#D0D0D0' 
                        : hoveredButton === `${row.id}-restore` 
                          ? 'rgb(0, 92, 188)' 
                          : '#3A3A3A'
                    } />
                  </TouchableOpacity>
                </DLOTooltip>
              </View>
            </View>
          </View>
        ))}

        {/* Save Button Row */}
        <View style={styles.saveButtonRow}>
          <DLOButton
            text={isSaved ? 'Saved' : 'Save'}
            onPress={handleBulkSave}
            size="medium"
            variant="primary"
            style={styles.saveButton}
            disabled={isSaveDisabled() || isSaved}
            isLoading={isSaving}
          />
        </View>
      </View>

      {/* Add Zone Modal */}
      <DLOModal
        visible={isAddZoneModalVisible}
        onClose={handleZoneModalCancel}
        title="Edit Zone"
        primaryButtonText="Save"
        secondaryButtonText="Cancel"
        onPrimaryPress={handleZoneModalSave}
        onSecondaryPress={handleZoneModalCancel}
        primaryButtonDisabled={false}
        width={400}
        showCloseIcon={false}
      >
        <View style={styles.modalContent}>
          {modalZones.length === 0 ? (
            // Show message if no zones are available at all
            <View style={styles.noZonesContainer}>
              <Text style={styles.noZonesText}>
                No zones available. Please contact administrator.
              </Text>
            </View>
          ) : (
            modalZones.map((zone, index) => (
              <View key={zone.id} style={styles.zoneItem}>
                <View style={styles.zoneItemLeft}>
                  <DragHandleIcon color={zone.enabled ? '#3A3A3A' : '#CCCCCC'} />
                  <Text style={[
                    styles.zoneItemText,
                    { color: zone.enabled ? '#3A3A3A' : '#A0A0A0', fontWeight: 'bold' }
                  ]}>
                    {zone.name}
                  </Text>
                </View>
                <DLORadioButton
                  selected={zone.enabled}
                  onPress={() => handleZoneToggle(zone.id, !zone.enabled)}
                  size="medium"
                />
              </View>
            ))
          )}
        </View>
      </DLOModal>

      {/* API Response Modal */}
      <DLOModal
        visible={showApiModal}
        onClose={() => setShowApiModal(false)}
        title={apiMessage?.type === 'success' ? 'Success' : 'Error'}
        primaryButtonText="OK"
        secondaryButtonText=""
        onPrimaryPress={() => setShowApiModal(false)}
        width={400}
        showCloseIcon={false}
      >
        <View style={styles.apiModalContent}>
          <Text style={styles.apiModalMessage}>
            {apiMessage?.message}
          </Text>
        </View>
      </DLOModal>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
    minWidth: '100%',
  },
  container: {
    borderRadius: 8,
    backgroundColor: '#FBFCFE',
    borderWidth: 1,
    borderColor: '#E0E0E0',
    overflow: 'hidden',
    width: '100%',
    minWidth: Platform.select({
      web: 1400,
      default: 1200,
    }),
    maxWidth: '100%',
  },
  
  // Main Header
  mainHeader: {
    backgroundColor: '#005CBC',
    flexDirection: 'row',
    alignItems: 'center',
    height: Platform.select({
      web: 48,
      default: 56,
    }),
  },
  addZoneButton: {
    width: Platform.select({
      web: 100,
      default: 100,
    }),
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  addZoneText: {
    color: '#FFFFFF',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 12,
    fontWeight: '700',
    lineHeight: Platform.select({
      web: 20,
      default: 18,
    }),
    textAlign: 'center',
  },
  headerDivider: {
    width: 1,
    height: 50,
    backgroundColor: '#FFFFFF',
  },
  headerDividerAfterHistorySection: {
    width: 1,
    height: 50,
    backgroundColor: '#FFFFFF',
  },
  historicalSection: {
    flex: 1,
    minWidth: Platform.select({
      web: 500,
      default: 400,
    }),
    alignItems: 'center',
    justifyContent: 'center',
  },
  fixedSection: {
    flex: 1,
    minWidth: Platform.select({
      web: 500,
      default: 400,
    }),
    alignItems: 'center',
    justifyContent: 'center',
  },
  actionSection: {
    flex: 0.1,
    minWidth: Platform.select({
      web: 200,
      default: 200,
    }),
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerSectionText: {
    color: '#FFFFFF',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: Platform.select({
      web: 12,
      default: 11,
    }),
    fontWeight: '700',
    lineHeight: Platform.select({
      web: 18,
      default: 16,
    }),
    textTransform: 'uppercase',
    textAlign: 'center',
  },

  // Sub Header
  subHeader: {
    backgroundColor: '#EFF5FC',
    flexDirection: 'row',
    alignItems: 'center',
    height: Platform.select({
      web: 40,
      default: 48,
    }),
    borderBottomColor: '#E0E0E0',
  },
  zoneSubColumn: {
    width: Platform.select({
      web: 100,
      default: 100,
    }),
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  historicalDaysGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  fixedDaysGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  daySubColumn: {
    flex: 1,
    minWidth: Platform.select({
      web: 93,
      default: 93,
    }),
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: Platform.select({
      web: 8,
      default: 12,
    }),
  },
  dayColumnDivider: {
    width: 1,
    height: 38,
    backgroundColor: '#E0E0E0',
    alignSelf: 'stretch',
  },
  actionSubColumn: {
    flex: 0.1,
    minWidth: Platform.select({
      web: 200,
      default: 200,
    }),
    alignItems: 'center',
    justifyContent: 'center',
    height: Platform.select({
      web: 40,
      default: 48,
    }),
  },
  subHeaderText: {
    color: '#3A3A3A',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: Platform.select({
      web: 12,
      default: 12,
    }),
    fontWeight: 'bold',
    lineHeight: Platform.select({
      web: 16,
      default: 18,
    }),
    textAlign: 'center',
  },

  // Data Rows
  dataRow: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: Platform.select({
      web: 48,
      default: 56,
    }),
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
    backgroundColor: '#FFFFFF',
  },
  lastDataRow: {
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  zoneText: {
    color: '#3A3A3A',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 12,
    fontWeight: '500',
    lineHeight: 18,
    textAlign: 'center',
  },
  inputColumnDivider: {
    width: 1,
    height: 56,
    backgroundColor: '#E0E0E0',
    alignSelf: 'center',
  },
  inputContainer: {
    flex: 1,
    minWidth: Platform.select({
      web: 75,
      default: 75,
    }),
    alignItems: 'center',
    justifyContent: 'center',
  },
  input: {
    width: Platform.select({
      web: 75,
      default: 75,
    }),
    minHeight: Platform.select({
      web: 28,
      default: 32,
    }),
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#E0E0E0',
    paddingHorizontal: Platform.select({
      web: 8,
      default: 12,
    }),
    paddingVertical: Platform.select({
      web: 4,
      default: 6,
    }),
    fontSize: Platform.select({
      web: 12,
      default: 14,
    }),
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Regular',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontWeight: '400',
    lineHeight: Platform.select({
      web: 18,
      default: 20,
    }),
    textAlign: 'center',
    color: '#3A3A3A',
  },
  historicalInput: {
    backgroundColor: '#D0D0D0',
  },
  fixedInput: {
    backgroundColor: '#FBFCFE',
  },

  // Save Button
  saveButtonRow: {
    height: 56,
    paddingHorizontal: 8,
    justifyContent: 'center',
    alignItems: 'flex-end',
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
    backgroundColor: '#FBFCFE',
  },
  saveButton: {
    width: 90,
    height: 32,
    borderRadius: 24,
    backgroundColor: '#005CBC',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 16,
    marginRight: 16,
  },
  saveButtonDisabled: {
    backgroundColor: '#D0D0D0',
  },
  saveButtonText: {
    color: '#FFFFFF',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Bold',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 20,
  },
  saveButtonTextDisabled: {
    color: '#A0A0A0',
  },

  // Action Buttons for each row
  actionButtonsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: Platform.select({
      web: 24,
      default: 24,
    }),
  },
  actionButton: {
    width: Platform.select({
      web: 24,
      default: 28,
    }),
    height: Platform.select({
      web: 24,
      default: 28,
    }),
    borderRadius: Platform.select({
      web: 12,
      default: 14,
    }),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },

  // Modal styles
  modalContent: {
    paddingVertical: 16,
  },
  modalLabel: {
    color: '#3A3A3A',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 20,
    marginBottom: 8,
  },
  apiModalContent: {
    paddingVertical: 16,
    alignItems: 'center',
  },
  apiModalMessage: {
    color: '#3A3A3A',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 24,
    textAlign: 'center',
  },
  zoneItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#D7E5F8',
  },
  zoneItemLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  zoneItemText: {
    marginLeft: 12,
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
  noZonesContainer: {
    paddingVertical: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  noZonesText: {
    color: '#A0A0A0',
    fontSize: 14,
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
    textAlign: 'center',
  },
  inTableIndicator: {
    color: '#A0A0A0',
    fontSize: 12,
    fontWeight: '400',
    fontStyle: 'italic',
  },
  modalSectionTitle: {
    color: '#3A3A3A',
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 16,
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Medium',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
  modalHelpText: {
    color: '#666666',
    fontSize: 12,
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
    lineHeight: 16,
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Regular',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
});

export default HistoricalHoursByDayAverage;
